<printheaderview [hasimage]="1"></printheaderview>
<div class="row" *ngFor="let l of CurrentBillItemsByChargeEntryCodeController">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-11 text-align-center">
            <label class="margin-bottom-10px font-familyhead">Department of Andrology</label>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.PatientName}}</label>
                </div>
              </div>

              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient Reg No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.PatientCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>

            </div>

            <div class="col-print-6 margin-top-10 margin-bottom-10px">

              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Lab Order:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>

            </div>
          </div>
        </div>


        <!--<div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px border-bot-1px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-bold">Test Name</label>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">Result</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">Biological Reference Intervals</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-normal">Specimen Collection Date/Time:</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">12-Nov-2019/4:00 PM</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Abstinence: 03</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px border-bot-1px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal padding-right-10px">SEMEN FREEZING</label>
              <!--<label class="margin-bottom-0px font-family font-weight-normal">Specimen:</label>-->
            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family font-weight-normal">Specimen:</label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">Serum</label>
                </div>
              </div>


            </div>

          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-12">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">Physical Examination</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">LIQUEFACTION</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">30 min</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">< 30 min</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">APPEARANCE</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Gray-Opaque</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Gray-Opaque</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">VISCOSITY</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Normal</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Normal</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">VOLUME</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">3.0 ML</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">>=1.5ML</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">PH</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">7.4 ML</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">7.2 or more</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-12">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">Microscopic Examination</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">SPERM CONCENTRATION</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">60 mil/ml</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Ã¢â€°Â¥ 15 millions/ml</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">AGGLUTINATION</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">CLUMPING</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- MANU</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-12">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">Physical Examination</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">LIQUEFACTION</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">30 min</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">< 30 min</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">APPEARANCE</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Gray-Opaque</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Gray-Opaque</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">VISCOSITY</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Normal</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Normal</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">VOLUME</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">3.0 ML</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">>=1.5ML</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">PH</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">7.4 ML</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">7.2 or more</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-12">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">Microscopic Examination</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">SPERM CONCENTRATION</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">60 mil/ml</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Ã¢â€°Â¥ 15 millions/ml</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">AGGLUTINATION</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- Manual</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-7">
                  <label class="margin-bottom-0px font-family font-weight-normal">CLUMPING</label>
                </div>
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-family13px">- MANU</label>
                </div>
              </div>
            </div>
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Absent</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-12">
              <label class="margin-bottom-0px font-family font-weight-bold">Comments:</label>
            </div>

          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">1 Vial Frozen</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-11">
          <div class="row margin-left-0px">
            <div class="col-print-12 text-align-center">
              <label class="margin-bottom-0px font-family">---------- End of Report ----------</label>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<printlabfooterview></printlabfooterview>


